import React from 'react';
import classes from './style.module.scss';
import { TrainingDetailParticipant } from '~/training/types';
import ParticipantRow from '../ParticipantRow';

export interface ParticipantListProps {
  participants: TrainingDetailParticipant[];
  showDetails: boolean;
}

export type ParticipantListComponent = React.FC<ParticipantListProps>;

const ParticipantList: ParticipantListComponent = ({ participants, showDetails }) => {
  return (
    <ul className={classes['trainee-list']}>
      {participants.map((participant) => (
        <ParticipantRow
          key={participant.id}
          participant={participant}
          showDetails={showDetails}
        />
      ))}
    </ul>
  );
};

export default ParticipantList;
